import { IInterviewSettings } from './../../models/interview-handler.models';
import { Injectable } from '@angular/core';

import { IEvaluationResult, IInterviewFinalizer, IInterviewHandler } from '../../models/interview-handler.models';
import { IInterviewDataProvider } from './data-providers.models';

export const interviewDefaultDataProviderToken = 'interview-default-data-provider';

@Injectable()
export class InterviewDefaultDataProviderService implements IInterviewDataProvider {

    context: any;

    get interviewFinalizer(): IInterviewFinalizer {
        return null;
    }

    async configure(context: any) {
        this.context = context;

        return {};
    }

    async canInitializeInterview(handler?: IInterviewHandler): Promise<boolean> {
        return true;
    }

    async buildSettings(settings: IInterviewSettings): Promise<Partial<IInterviewSettings>> {
        return settings;
    }

    processCommandCancel(): Promise<any> {
        return Promise.resolve(null);
    }

    generateContextData(contextData?: any, input?: any) {
        return {
            ...contextData,
            ...input
        };
    }

    processEvaluation(evaluationResult: IEvaluationResult) {
    }

}
